/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AggregateKeyInfo } from './AggregateKeyInfo';
import {
    AggregateKeyInfoFromJSON,
    AggregateKeyInfoFromJSONTyped,
    AggregateKeyInfoToJSON,
} from './AggregateKeyInfo';

/**
 * 
 * @export
 * @interface ChefsEntrepriseDoublonSearchDto
 */
export interface ChefsEntrepriseDoublonSearchDto {
    /**
     * 
     * @type {number}
     * @memberof ChefsEntrepriseDoublonSearchDto
     */
    idchefEntreprise?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ChefsEntrepriseDoublonSearchDto
     */
    idsiegeSocial?: number;
    /**
     * 
     * @type {string}
     * @memberof ChefsEntrepriseDoublonSearchDto
     */
    nom?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChefsEntrepriseDoublonSearchDto
     */
    prenom?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChefsEntrepriseDoublonSearchDto
     */
    registreNational?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof ChefsEntrepriseDoublonSearchDto
     */
    dateNaissance?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof ChefsEntrepriseDoublonSearchDto
     */
    nationalite?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ChefsEntrepriseDoublonSearchDto
     */
    idpersonne?: number | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof ChefsEntrepriseDoublonSearchDto
     */
    selectedIds?: Array<number> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof ChefsEntrepriseDoublonSearchDto
     */
    availableIds?: Array<number> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof ChefsEntrepriseDoublonSearchDto
     */
    sortKey?: Array<string> | null;
    /**
     * 
     * @type {Array<AggregateKeyInfo>}
     * @memberof ChefsEntrepriseDoublonSearchDto
     */
    aggregateKeys?: Array<AggregateKeyInfo> | null;
    /**
     * 
     * @type {number}
     * @memberof ChefsEntrepriseDoublonSearchDto
     */
    forceSkip?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ChefsEntrepriseDoublonSearchDto
     */
    forceTake?: number | null;
    /**
     * 
     * @type {any}
     * @memberof ChefsEntrepriseDoublonSearchDto
     */
    parameters?: any | null;
    /**
     * 
     * @type {string}
     * @memberof ChefsEntrepriseDoublonSearchDto
     */
    filter?: string | null;
}

/**
 * Check if a given object implements the ChefsEntrepriseDoublonSearchDto interface.
 */
export function instanceOfChefsEntrepriseDoublonSearchDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ChefsEntrepriseDoublonSearchDtoFromJSON(json: any): ChefsEntrepriseDoublonSearchDto {
    return ChefsEntrepriseDoublonSearchDtoFromJSONTyped(json, false);
}

export function ChefsEntrepriseDoublonSearchDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChefsEntrepriseDoublonSearchDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idchefEntreprise': !exists(json, 'idchefEntreprise') ? undefined : json['idchefEntreprise'],
        'idsiegeSocial': !exists(json, 'idsiegeSocial') ? undefined : json['idsiegeSocial'],
        'nom': !exists(json, 'nom') ? undefined : json['nom'],
        'prenom': !exists(json, 'prenom') ? undefined : json['prenom'],
        'registreNational': !exists(json, 'registreNational') ? undefined : json['registreNational'],
        'dateNaissance': !exists(json, 'dateNaissance') ? undefined : (json['dateNaissance'] === null ? null : new Date(json['dateNaissance'])),
        'nationalite': !exists(json, 'nationalite') ? undefined : json['nationalite'],
        'idpersonne': !exists(json, 'idpersonne') ? undefined : json['idpersonne'],
        'selectedIds': !exists(json, 'selectedIds') ? undefined : json['selectedIds'],
        'availableIds': !exists(json, 'availableIds') ? undefined : json['availableIds'],
        'sortKey': !exists(json, 'sortKey') ? undefined : json['sortKey'],
        'aggregateKeys': !exists(json, 'aggregateKeys') ? undefined : (json['aggregateKeys'] === null ? null : (json['aggregateKeys'] as Array<any>).map(AggregateKeyInfoFromJSON)),
        'forceSkip': !exists(json, 'forceSkip') ? undefined : json['forceSkip'],
        'forceTake': !exists(json, 'forceTake') ? undefined : json['forceTake'],
        'parameters': !exists(json, 'parameters') ? undefined : json['parameters'],
        'filter': !exists(json, 'filter') ? undefined : json['filter'],
    };
}

export function ChefsEntrepriseDoublonSearchDtoToJSON(value?: ChefsEntrepriseDoublonSearchDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idchefEntreprise': value.idchefEntreprise,
        'idsiegeSocial': value.idsiegeSocial,
        'nom': value.nom,
        'prenom': value.prenom,
        'registreNational': value.registreNational,
        'dateNaissance': value.dateNaissance === undefined ? undefined : (value.dateNaissance === null ? null : value.dateNaissance.toISOString()),
        'nationalite': value.nationalite,
        'idpersonne': value.idpersonne,
        'selectedIds': value.selectedIds,
        'availableIds': value.availableIds,
        'sortKey': value.sortKey,
        'aggregateKeys': value.aggregateKeys === undefined ? undefined : (value.aggregateKeys === null ? null : (value.aggregateKeys as Array<any>).map(AggregateKeyInfoToJSON)),
        'forceSkip': value.forceSkip,
        'forceTake': value.forceTake,
        'parameters': value.parameters,
        'filter': value.filter,
    };
}

